<template>
  <div>
    <div class="row justify-between">
      <div class="row items-center">
        <div>
          <q-btn color="accent" @click="backFromOptionForm" flat>
            <q-icon name="mdi-arrow-left"> </q-icon>
          </q-btn>
        </div>
        <div class="title q-my-none q-mx-none">Options</div>
      </div>

      <div class="row justify-end">
        <q-btn color="primary" @click="saveOption(null)" class="float-right">
          <q-icon name="mdi-plus-circle"> </q-icon>
          <span class="sustainability-font q-mx-sm" style="font-size: 13px">
            Save
          </span>
        </q-btn>
      </div>
    </div>
    <q-form ref="form">
      <div class="row q-col-gutter-md">
        <div class="col-4">
          <q-input
            v-model="formData.text"
            label="Answer title"
            :rules="[(v) => !!v || 'Field is Required']"
          >
          </q-input>
        </div>
        <div class="col-4">
          <q-input
            v-model="formData.idx"
            label="Rank"
            :rules="[
              (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
            ]"
          >
          </q-input>
        </div>
        <div class="col-4">
          <q-select
            v-model="formData.type"
            label="Type"
            @input="clearValues"
            :options="typeList"
            :rules="[(v) => !!v || 'Field is Required']"
          >
          </q-select>
        </div>
        <div class="col-12">
          <q-select
            v-if="formData.type == 'Source'"
            v-model="formData.values"
            multiple
            :options="sourcesList"
            map-options
            option-label="sourceName"
            emit-value
            use-chips
            label="Select Sources"
          >
          </q-select>
          <q-select
            v-else
            v-model="formData.values"
            multiple
            :options="categoriesList"
            map-options
            option-label="name"
            emit-value
            use-chips
            label="Select Category"
          >
          </q-select>
        </div>
        <div class="col-12">
          <p class="text-bold">Whats That - Side Panel</p>
          <q-editor
            style="height: 300px"
            v-model="formData.whatsThat"
            :dense="$q.screen.lt.md"
            :toolbar="[
              [
                {
                  label: $q.lang.editor.align,
                  icon: $q.iconSet.editor.align,
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['left', 'center', 'right', 'justify'],
                },
                {
                  label: $q.lang.editor.align,
                  icon: $q.iconSet.editor.align,
                  fixedLabel: true,
                  options: ['left', 'center', 'right', 'justify'],
                },
              ],
              [
                'bold',
                'italic',
                'strike',
                'underline',
                'subscript',
                'superscript',
              ],
              ['token', 'hr', 'link', 'custom_btn'],
              ['print', 'fullscreen'],
              [
                {
                  label: $q.lang.editor.formatting,
                  icon: $q.iconSet.editor.formatting,
                  list: 'no-icons',
                  options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code'],
                },
                {
                  label: $q.lang.editor.fontSize,
                  icon: $q.iconSet.editor.fontSize,
                  fixedLabel: true,
                  fixedIcon: true,
                  list: 'no-icons',
                  options: [
                    'size-1',
                    'size-2',
                    'size-3',
                    'size-4',
                    'size-5',
                    'size-6',
                    'size-7',
                  ],
                },
                {
                  label: $q.lang.editor.defaultFont,
                  icon: $q.iconSet.editor.font,
                  fixedIcon: true,
                  list: 'no-icons',
                  options: [
                    'default_font',
                    'arial',
                    'arial_black',
                    'comic_sans',
                    'courier_new',
                    'impact',
                    'lucida_grande',
                    'times_new_roman',
                    'verdana',
                  ],
                },
                'removeFormat',
              ],
              ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

              ['undo', 'redo'],
              ['viewsource'],
            ]"
            :fonts="{
              arial: 'Arial',
              arial_black: 'Arial Black',
              comic_sans: 'Comic Sans MS',
              courier_new: 'Courier New',
              impact: 'Impact',
              lucida_grande: 'Lucida Grande',
              times_new_roman: 'Times New Roman',
              verdana: 'Verdana',
            }"
          />
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    mounted() {
      this.$store.dispatch(
        "sources/loadSourcesByOutcomeID",
        this.$route.params.id
      );
      this.$store.dispatch(
        "outcomes/categories/loadAllByOutcomesID",
        this.$route.params.id
      );
      this.init();
    },
    computed: {
      ...mapGetters({
        data: "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/selectedOption",
        sourcesList: "sources/sourcesOutcomesListOrdered",
        categoriesList: "outcomes/categories/list",
      }),
    },
    data: () => ({
      formData: {
        type: "Source",
        values: [],
        whatsThat: "",
      },
      initialSourceValues: [],
      initialCategoryValues: [],
      typeList: ["Source", "Category"],
    }),
    methods: {
      init() {
        if (
          this.$route.params.hasOwnProperty("outcomePlanQuestionnaireOptions_id")
        ) {
          this.$store
            .dispatch(
              "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/loadByID",
              this.$route.params.outcomePlanQuestionnaireOptions_id
            )
            .then(() => {
              if (this.data) {
                this.formData = JSON.parse(JSON.stringify(this.data));
                this.formData.values = JSON.parse(this.formData.values);
                if (this.formData.type == "Category") {
                  this.initialCategoryValues = this.formData.values;
                } else {
                  this.initialSourceValues = this.formData.values;
                }
              }
            });
        }
      },
      backFromOptionForm() {
        this.$emit("backFromForm");
      },
      clearValues() {
        this.formData.values = [];

        if (this.formData.type == "Category") {
          this.formData.values = this.initialCategoryValues;
        } else {
          this.formData.values = this.initialSourceValues;
        }

      },
      async saveOption(deletedPayload) {
        let isValid = null;
        if (deletedPayload) {
          isValid = true;
        } else {
          isValid = await this.$refs.form.validate();
        }

        if (isValid) {
          let payload = null;
          if (deletedPayload) {
            payload = deletedPayload;
          } else {
            payload = JSON.parse(JSON.stringify(this.formData));
            payload["values"] = JSON.stringify(this.formData.values);
            payload["status"] = "live";
          }
          let result = await this.$store.dispatch(
            "outcomePlanQuestionnaire/outcomePlanQuestionnaireOptions/save",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.backFromOptionForm();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }
</style>
